<template>
	<div>
		<div class="field">
			<label class="label">{{ $t("confirm-sign.signature") }}</label>
			<div class="control">
				<label class="checkbox mb-2">
					<input
						type="checkbox"
						v-model="addSignerName"
						:disabled="!isLogged"
					/>
					{{ $t("confirm-sign.add-signer-name") }}
				</label>
			</div>
			<div class="control">
				<button class="button" @click="sign">
					{{ $t("confirm-sign.sign") }}
				</button>
			</div>
		</div>

		<div class="modal" :class="{ 'is-active': showConfirm }">
			<div class="modal-background"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ $t("confirm-sign.title") }}
					</p>
					<button class="delete" @click="close"></button>
				</header>
				<section class="modal-card-body">
					<div class="has-text-centered">
						<div v-if="signing">
							<Loading />
							<p>{{ $t("confirm-sign.signing") }}</p>
						</div>
						<div v-else>
							<div v-if="correct">
								<Icon family="fa" name="fa-check fa-2x" />
								<div>
									<p>{{ $t("confirm-sign.correct-sign") }}</p>
								</div>
							</div>

							<div v-if="!correct">
								<Icon family="fa" name="fa-times fa-2x" />
								<div>
									<p>
										{{ $t("confirm-sign.error-signing") }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot is-justify-content-flex-end">
					<button class="button" @click="close">
						<span> {{ $t("confirm-sign.close") }}</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading";

export default {
	name: "confirm-sign",
	components: {
		Loading,
	},
	props: {
		signalRSocket: { type: Object, required: true },
	},
	data() {
		return {
			showConfirm: false,

			signing: false,
			correct: false,

			addSignerName: false,
		};
	},
	mounted() {
		this.addSignerName = this.getAddSignerName;
	},
	computed: {
		...mapGetters("conference", [
			"getConferenceId",
			"getParticipantId",
			"getUserName",
		]),
		...mapGetters("signature", [
			"getSignature",
			"getSignatureInfo",
			"getAddSignerName",
		]),
		...mapGetters("colaborativeBoard", [
			"getFileId",
			"getPage",
			"getPageSize",
		]),
		...mapGetters("oidcStore", ["oidcIsAuthenticated"]),
		isLogged() {
			return this.oidcIsAuthenticated;
		},
	},
	methods: {
		...mapActions("signature", ["setSignature", "setSignatureInfo"]),
		close() {
			if (this.correct) {
				this.sendSignAnswer();

				this.signalRSocket.invoke(
					"ReloadSharedDocument",
					this.getConferenceId,
					this.getFileId
				);
			}
			this.setSignature({ signature: null });
			this.setSignatureInfo(null);
		},
		async sendSignAnswer() {
			this.signalRSocket.invoke(
				"SendSignAnswer",
				this.getConferenceId,
				this.getFileId,
				this.getUserName
			);
		},
		async sign() {
			this.signing = true;
			this.showConfirm = true;
			try {
				let signatureInfo = this.getSignatureInfo;
				let data = {
					roomId: this.getConferenceId,
					fileId: this.getFileId,
					participantId: this.getParticipantId,
					base64Signature: this.getSignature,
					signatureInfo: {
						page: this.getPage,
						pageWidth: this.getPageSize.width,
						pageHeight: this.getPageSize.height,
						width: signatureInfo.width,
						height: signatureInfo.height,
						x: signatureInfo.x,
						y: signatureInfo.y,
						addSignerName: this.addSignerName,
					},
				};

				let response = await RepositoryFactory.files.signSharedFile(
					data
				);
				window.console.log(response);
				this.correct = true;
			} catch (error) {
				window.console.log(error);
				this.correct = false;
			}
			this.signing = false;
		},
	},
};
</script>